import { smallBold, typoBase } from "./typography";

export const verticalTabStyles = () => ({
  "& .MuiTab-root": {
    ...typoBase,
    textTransform: "none", // Disable uppercase text
    minWidth: 100, // Minimum width for tabs
    minHeight: 36, // Minimum height for tabs
    padding: "6px 16px", // Padding for tabs
    alignItems: "flex-start", // Align text to the start
    fontFamily:
      "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
      fontSize: "10.5px",
    fontWeight: 400,
    // Text color
  },
  "& .Mui-selected": {
    ...smallBold,
    color: "#2B80B6",
    fontFamily:
      "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
      fontSize: "10.5px",
    fontWeight: 400,
    backgroundColor: "rgba(46, 128, 175, 0.08)", // Blue color with 8% opacity
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#2B80B6", // Indicator color
  },
});
